import React from 'react';

function FixedHeaderFooterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 20"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-959 -1745)">
          <path d="M984 1763a2 2 0 01-2 2h-21a2 2 0 01-2-2v-16a2 2 0 012-2h21a2 2 0 012 2v16zm-3-12h-19v11h19v-11z" />
        </g>
      </g>
    </svg>
  );
}

export default FixedHeaderFooterIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/FixedHeaderFooter.js